/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const ApiBaseUrlToken = new InjectionToken<string>('ApiBaseUrlToken');

export interface IUserGeneratedClient {
    user_GetRealms(): Observable<string[]>;
    user_GetCapabilities(realmId: string | null): Observable<Capabilities>;
}

@Injectable({
    providedIn: 'root'
})
export class UserGeneratedClient implements IUserGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    user_GetRealms(): Observable<string[]> {
        let url_ = this.baseUrl + "/realms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_GetRealms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_GetRealms(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processUser_GetRealms(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    user_GetCapabilities(realmId: string | null): Observable<Capabilities> {
        let url_ = this.baseUrl + "/rlm/{realmId}";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUser_GetCapabilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUser_GetCapabilities(<any>response_);
                } catch (e) {
                    return <Observable<Capabilities>><any>_observableThrow(e);
                }
            } else
                return <Observable<Capabilities>><any>_observableThrow(response_);
        }));
    }

    protected processUser_GetCapabilities(response: HttpResponseBase): Observable<Capabilities> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Capabilities>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Capabilities>(<any>null);
    }
}

export interface IConfigGeneratedClient {
    /**
     * Get config
     */
    config_Get(): Observable<Config>;
}

@Injectable({
    providedIn: 'root'
})
export class ConfigGeneratedClient implements IConfigGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    /**
     * Get config
     */
    config_Get(): Observable<Config> {
        let url_ = this.baseUrl + "/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig_Get(<any>response_);
                } catch (e) {
                    return <Observable<Config>><any>_observableThrow(e);
                }
            } else
                return <Observable<Config>><any>_observableThrow(response_);
        }));
    }

    protected processConfig_Get(response: HttpResponseBase): Observable<Config> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Config>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Config>(<any>null);
    }
}

export interface IFilterGeneratedClient {
    /**
     * Get all student filters
     */
    filter_Get(realmId: string): Observable<Filter[]>;
    filter_GetFilterValuesFremdsprachig(realmId: string): Observable<DynamicFilterEntry[]>;
    filter_GetFilterValuesKlasse(realmId: string): Observable<DynamicFilterEntry[]>;
    filter_GetFilterValuesPlanKlasse(realmId: string): Observable<DynamicFilterEntry[]>;
    filter_GetFilterValuesStufe(realmId: string): Observable<DynamicFilterEntry[]>;
    filter_GetFilterValuesGeschlecht(realmId: string): Observable<DynamicFilterEntry[]>;
    filter_GetFilterValueSchulhausTyp(realmId: string): Observable<DynamicFilterEntry[]>;
}

@Injectable({
    providedIn: 'root'
})
export class FilterGeneratedClient implements IFilterGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    /**
     * Get all student filters
     */
    filter_Get(realmId: string): Observable<Filter[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/filter";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilter_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilter_Get(<any>response_);
                } catch (e) {
                    return <Observable<Filter[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Filter[]>><any>_observableThrow(response_);
        }));
    }

    protected processFilter_Get(response: HttpResponseBase): Observable<Filter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Filter[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Filter[]>(<any>null);
    }

    filter_GetFilterValuesFremdsprachig(realmId: string): Observable<DynamicFilterEntry[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/filter/GetFilterValuesFremdsprachig";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilter_GetFilterValuesFremdsprachig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilter_GetFilterValuesFremdsprachig(<any>response_);
                } catch (e) {
                    return <Observable<DynamicFilterEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DynamicFilterEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processFilter_GetFilterValuesFremdsprachig(response: HttpResponseBase): Observable<DynamicFilterEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DynamicFilterEntry[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicFilterEntry[]>(<any>null);
    }

    filter_GetFilterValuesKlasse(realmId: string): Observable<DynamicFilterEntry[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/filter/GetFilterValuesKlasse";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilter_GetFilterValuesKlasse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilter_GetFilterValuesKlasse(<any>response_);
                } catch (e) {
                    return <Observable<DynamicFilterEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DynamicFilterEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processFilter_GetFilterValuesKlasse(response: HttpResponseBase): Observable<DynamicFilterEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DynamicFilterEntry[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicFilterEntry[]>(<any>null);
    }

    filter_GetFilterValuesPlanKlasse(realmId: string): Observable<DynamicFilterEntry[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/filter/GetFilterValuesPlanKlasse";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilter_GetFilterValuesPlanKlasse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilter_GetFilterValuesPlanKlasse(<any>response_);
                } catch (e) {
                    return <Observable<DynamicFilterEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DynamicFilterEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processFilter_GetFilterValuesPlanKlasse(response: HttpResponseBase): Observable<DynamicFilterEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DynamicFilterEntry[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicFilterEntry[]>(<any>null);
    }

    filter_GetFilterValuesStufe(realmId: string): Observable<DynamicFilterEntry[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/filter/GetFilterValuesStufe";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilter_GetFilterValuesStufe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilter_GetFilterValuesStufe(<any>response_);
                } catch (e) {
                    return <Observable<DynamicFilterEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DynamicFilterEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processFilter_GetFilterValuesStufe(response: HttpResponseBase): Observable<DynamicFilterEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DynamicFilterEntry[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicFilterEntry[]>(<any>null);
    }

    filter_GetFilterValuesGeschlecht(realmId: string): Observable<DynamicFilterEntry[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/filter/GetFilterValuesGeschlecht";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilter_GetFilterValuesGeschlecht(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilter_GetFilterValuesGeschlecht(<any>response_);
                } catch (e) {
                    return <Observable<DynamicFilterEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DynamicFilterEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processFilter_GetFilterValuesGeschlecht(response: HttpResponseBase): Observable<DynamicFilterEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DynamicFilterEntry[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicFilterEntry[]>(<any>null);
    }

    filter_GetFilterValueSchulhausTyp(realmId: string): Observable<DynamicFilterEntry[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/filter/GetFilterValuesSchulhausTyp";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilter_GetFilterValueSchulhausTyp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilter_GetFilterValueSchulhausTyp(<any>response_);
                } catch (e) {
                    return <Observable<DynamicFilterEntry[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<DynamicFilterEntry[]>><any>_observableThrow(response_);
        }));
    }

    protected processFilter_GetFilterValueSchulhausTyp(response: HttpResponseBase): Observable<DynamicFilterEntry[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DynamicFilterEntry[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DynamicFilterEntry[]>(<any>null);
    }
}

export interface IGebäudeGeneratedClient {
    /**
     * Get all buildings
     */
    gebäude_Get(realmId: string): Observable<Building[]>;
    gebäude_GetTypeNames(realmId: string): Observable<GebäudeTypeNames[]>;
}

@Injectable({
    providedIn: 'root'
})
export class GebäudeGeneratedClient implements IGebäudeGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    /**
     * Get all buildings
     */
    gebäude_Get(realmId: string): Observable<Building[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/buildings";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGebäude_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGebäude_Get(<any>response_);
                } catch (e) {
                    return <Observable<Building[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Building[]>><any>_observableThrow(response_);
        }));
    }

    protected processGebäude_Get(response: HttpResponseBase): Observable<Building[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Building[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Building[]>(<any>null);
    }

    gebäude_GetTypeNames(realmId: string): Observable<GebäudeTypeNames[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/buildings/getTypeNames";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGebäude_GetTypeNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGebäude_GetTypeNames(<any>response_);
                } catch (e) {
                    return <Observable<GebäudeTypeNames[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GebäudeTypeNames[]>><any>_observableThrow(response_);
        }));
    }

    protected processGebäude_GetTypeNames(response: HttpResponseBase): Observable<GebäudeTypeNames[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GebäudeTypeNames[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GebäudeTypeNames[]>(<any>null);
    }
}

export interface IAusnahmenGeneratedClient {
    /**
     * Get a single exception (mainly used as response to POST request)
     * @param id GUID
     */
    ausnahmen_GetById(id: string, realmId: string): Observable<GisException>;
    /**
     * Change perimeter of an existing GisException
     * @param perimeterId New perimeter (GUID)
     */
    ausnahmen_Change(id: string, perimeterId: string, realmId: string): Observable<void>;
    /**
     * Delete an exception
     * @param id GUID
     */
    ausnahmen_Delete(id: string, realmId: string): Observable<void>;
    /**
     * Post a new exception
     * @param realmId RealmID
     * @param exception GisException to add
     */
    ausnahmen_Post(realmId: string | null, exception: GisException): Observable<GisException>;
}

@Injectable({
    providedIn: 'root'
})
export class AusnahmenGeneratedClient implements IAusnahmenGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    /**
     * Get a single exception (mainly used as response to POST request)
     * @param id GUID
     */
    ausnahmen_GetById(id: string, realmId: string): Observable<GisException> {
        let url_ = this.baseUrl + "/rlm/{realmId}/gisexceptions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAusnahmen_GetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAusnahmen_GetById(<any>response_);
                } catch (e) {
                    return <Observable<GisException>><any>_observableThrow(e);
                }
            } else
                return <Observable<GisException>><any>_observableThrow(response_);
        }));
    }

    protected processAusnahmen_GetById(response: HttpResponseBase): Observable<GisException> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GisException>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GisException>(<any>null);
    }

    /**
     * Change perimeter of an existing GisException
     * @param perimeterId New perimeter (GUID)
     */
    ausnahmen_Change(id: string, perimeterId: string, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/gisexceptions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(perimeterId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAusnahmen_Change(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAusnahmen_Change(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAusnahmen_Change(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Delete an exception
     * @param id GUID
     */
    ausnahmen_Delete(id: string, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/gisexceptions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAusnahmen_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAusnahmen_Delete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processAusnahmen_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Post a new exception
     * @param realmId RealmID
     * @param exception GisException to add
     */
    ausnahmen_Post(realmId: string | null, exception: GisException): Observable<GisException> {
        let url_ = this.baseUrl + "/rlm/{realmId}/gisexceptions";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exception);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAusnahmen_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAusnahmen_Post(<any>response_);
                } catch (e) {
                    return <Observable<GisException>><any>_observableThrow(e);
                }
            } else
                return <Observable<GisException>><any>_observableThrow(response_);
        }));
    }

    protected processAusnahmen_Post(response: HttpResponseBase): Observable<GisException> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <GisException>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GisException>(<any>null);
    }
}

export interface IKarteGeneratedClient {
    /**
     * Get map coordinates for the current realm
     */
    karte_Get(realmId: string): Observable<Coordinates>;
    /**
     * Set map coordinates configuration for the current realm
     */
    karte_Put(coordinates: Coordinates, realmId: string): Observable<Coordinates>;
}

@Injectable({
    providedIn: 'root'
})
export class KarteGeneratedClient implements IKarteGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    /**
     * Get map coordinates for the current realm
     */
    karte_Get(realmId: string): Observable<Coordinates> {
        let url_ = this.baseUrl + "/rlm/{realmId}/map";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKarte_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKarte_Get(<any>response_);
                } catch (e) {
                    return <Observable<Coordinates>><any>_observableThrow(e);
                }
            } else
                return <Observable<Coordinates>><any>_observableThrow(response_);
        }));
    }

    protected processKarte_Get(response: HttpResponseBase): Observable<Coordinates> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Coordinates>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Coordinates>(<any>null);
    }

    /**
     * Set map coordinates configuration for the current realm
     */
    karte_Put(coordinates: Coordinates, realmId: string): Observable<Coordinates> {
        let url_ = this.baseUrl + "/rlm/{realmId}/map";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(coordinates);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKarte_Put(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKarte_Put(<any>response_);
                } catch (e) {
                    return <Observable<Coordinates>><any>_observableThrow(e);
                }
            } else
                return <Observable<Coordinates>><any>_observableThrow(response_);
        }));
    }

    protected processKarte_Put(response: HttpResponseBase): Observable<Coordinates> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Coordinates>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Coordinates>(<any>null);
    }
}

export interface IKlassenGeneratedClient {
    /**
     * Get all relevant schoolclasses
     * @param planKlasse (optional) Planklasse (bool)
     */
    klassen_Get(realmId: string, planKlasse?: boolean | null | undefined): Observable<Schoolclass[]>;
}

@Injectable({
    providedIn: 'root'
})
export class KlassenGeneratedClient implements IKlassenGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    /**
     * Get all relevant schoolclasses
     * @param planKlasse (optional) Planklasse (bool)
     */
    klassen_Get(realmId: string, planKlasse?: boolean | null | undefined): Observable<Schoolclass[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/schoolclasses?";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        if (planKlasse !== undefined && planKlasse !== null)
            url_ += "planKlasse=" + encodeURIComponent("" + planKlasse) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKlassen_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKlassen_Get(<any>response_);
                } catch (e) {
                    return <Observable<Schoolclass[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Schoolclass[]>><any>_observableThrow(response_);
        }));
    }

    protected processKlassen_Get(response: HttpResponseBase): Observable<Schoolclass[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Schoolclass[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Schoolclass[]>(<any>null);
    }
}

export interface IPerimeterGeneratedClient {
    /**
     * Rename a perimeter
     * @param id GUID
     * @param name New name
     */
    perimeter_Rename(id: string, name: string, realmId: string): Observable<void>;
    /**
     * Delete a perimeter
     * @param id GUID
     */
    perimeter_Delete(id: string, realmId: string): Observable<void>;
    perimeter_SetKlasse(id: number, klasseId: number, realmId: string): Observable<void>;
    perimeter_SetPlanklasse(id: number, planKlasseId: number, realmId: string): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class PerimeterGeneratedClient implements IPerimeterGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    /**
     * Rename a perimeter
     * @param id GUID
     * @param name New name
     */
    perimeter_Rename(id: string, name: string, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/perimeter/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(name);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerimeter_Rename(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerimeter_Rename(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPerimeter_Rename(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Delete a perimeter
     * @param id GUID
     */
    perimeter_Delete(id: string, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/perimeter/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerimeter_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerimeter_Delete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPerimeter_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    perimeter_SetKlasse(id: number, klasseId: number, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/perimeter/{id}/setKlasse";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(klasseId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerimeter_SetKlasse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerimeter_SetKlasse(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPerimeter_SetKlasse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    perimeter_SetPlanklasse(id: number, planKlasseId: number, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/perimeter/{id}/setPlanklasse";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(planKlasseId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerimeter_SetPlanklasse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerimeter_SetPlanklasse(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPerimeter_SetPlanklasse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface IPlanungsvariantenGeneratedClient {
    /**
     * Get all planningvariants
     */
    planungsvarianten_Get(realmId: string): Observable<Planningvariant[]>;
    /**
     * Post a new planningvariant (without GIS data)
     * @param realmId RealmID
     * @param planningvariant Planningvariant to add
     */
    planungsvarianten_Post(realmId: string | null, planningvariant: Planningvariant): Observable<Planningvariant>;
    /**
     * Get a single planningvariant by ID with all related GIS data
     * @param id GUID
     */
    planungsvarianten_GetById(id: string, realmId: string): Observable<PlanningvariantWithGisDataFront>;
    /**
     * Update a planningvariant (with GIS data)
     * @param planningvariant Planningvariant with GIS data to update
     * @return Planningvariant updated
     */
    planungsvarianten_Update(planningvariant: PlanningvariantWithGisDataFront, realmId: string, id: string): Observable<void>;
    /**
     * Rename a planningvariant
     * @param id GUID
     * @param name New name
     */
    planungsvarianten_Rename(id: string, name: string, realmId: string): Observable<void>;
    /**
     * Delete a planningvariant
     * @param id GUID
     */
    planungsvarianten_Delete(id: string, realmId: string): Observable<void>;
    /**
     * Copy a planningvariant (with all related data)
     * @param realmId RealmID
     * @param id Planningvariant to copy
     * @param name Name of the new planningvariant
     */
    planungsvarianten_Copy(realmId: string | null, id: string, name: string): Observable<Planningvariant>;
}

@Injectable({
    providedIn: 'root'
})
export class PlanungsvariantenGeneratedClient implements IPlanungsvariantenGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    /**
     * Get all planningvariants
     */
    planungsvarianten_Get(realmId: string): Observable<Planningvariant[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/planningvariants";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlanungsvarianten_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlanungsvarianten_Get(<any>response_);
                } catch (e) {
                    return <Observable<Planningvariant[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Planningvariant[]>><any>_observableThrow(response_);
        }));
    }

    protected processPlanungsvarianten_Get(response: HttpResponseBase): Observable<Planningvariant[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Planningvariant[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Planningvariant[]>(<any>null);
    }

    /**
     * Post a new planningvariant (without GIS data)
     * @param realmId RealmID
     * @param planningvariant Planningvariant to add
     */
    planungsvarianten_Post(realmId: string | null, planningvariant: Planningvariant): Observable<Planningvariant> {
        let url_ = this.baseUrl + "/rlm/{realmId}/planningvariants";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(planningvariant);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlanungsvarianten_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlanungsvarianten_Post(<any>response_);
                } catch (e) {
                    return <Observable<Planningvariant>><any>_observableThrow(e);
                }
            } else
                return <Observable<Planningvariant>><any>_observableThrow(response_);
        }));
    }

    protected processPlanungsvarianten_Post(response: HttpResponseBase): Observable<Planningvariant> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <Planningvariant>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Planningvariant>(<any>null);
    }

    /**
     * Get a single planningvariant by ID with all related GIS data
     * @param id GUID
     */
    planungsvarianten_GetById(id: string, realmId: string): Observable<PlanningvariantWithGisDataFront> {
        let url_ = this.baseUrl + "/rlm/{realmId}/planningvariants/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlanungsvarianten_GetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlanungsvarianten_GetById(<any>response_);
                } catch (e) {
                    return <Observable<PlanningvariantWithGisDataFront>><any>_observableThrow(e);
                }
            } else
                return <Observable<PlanningvariantWithGisDataFront>><any>_observableThrow(response_);
        }));
    }

    protected processPlanungsvarianten_GetById(response: HttpResponseBase): Observable<PlanningvariantWithGisDataFront> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PlanningvariantWithGisDataFront>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanningvariantWithGisDataFront>(<any>null);
    }

    /**
     * Update a planningvariant (with GIS data)
     * @param planningvariant Planningvariant with GIS data to update
     * @return Planningvariant updated
     */
    planungsvarianten_Update(planningvariant: PlanningvariantWithGisDataFront, realmId: string, id: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/planningvariants/{id}";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(planningvariant);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlanungsvarianten_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlanungsvarianten_Update(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPlanungsvarianten_Update(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Rename a planningvariant
     * @param id GUID
     * @param name New name
     */
    planungsvarianten_Rename(id: string, name: string, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/planningvariants/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(name);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlanungsvarianten_Rename(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlanungsvarianten_Rename(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPlanungsvarianten_Rename(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Name not unique", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Delete a planningvariant
     * @param id GUID
     */
    planungsvarianten_Delete(id: string, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/planningvariants/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlanungsvarianten_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlanungsvarianten_Delete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processPlanungsvarianten_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Copy a planningvariant (with all related data)
     * @param realmId RealmID
     * @param id Planningvariant to copy
     * @param name Name of the new planningvariant
     */
    planungsvarianten_Copy(realmId: string | null, id: string, name: string): Observable<Planningvariant> {
        let url_ = this.baseUrl + "/rlm/{realmId}/planningvariants/{id}/copy";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(name);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPlanungsvarianten_Copy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlanungsvarianten_Copy(<any>response_);
                } catch (e) {
                    return <Observable<Planningvariant>><any>_observableThrow(e);
                }
            } else
                return <Observable<Planningvariant>><any>_observableThrow(response_);
        }));
    }

    protected processPlanungsvarianten_Copy(response: HttpResponseBase): Observable<Planningvariant> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result201: any = null;
            result201 = _responseText === "" ? null : <Planningvariant>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result201);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Planningvariant>(<any>null);
    }
}

export interface IPrognoseGeneratedClient {
    /**
     * Get Prognose
     */
    prognose_Get(planningvariantId: string, year: number, realmId: string): Observable<FileResponse | null>;
    prognose_GetYears(realmId: string): Observable<number[]>;
}

@Injectable({
    providedIn: 'root'
})
export class PrognoseGeneratedClient implements IPrognoseGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    /**
     * Get Prognose
     */
    prognose_Get(planningvariantId: string, year: number, realmId: string): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/rlm/{realmId}/forecast/{planningvariantId}/{year}";
        if (planningvariantId === undefined || planningvariantId === null)
            throw new Error("The parameter 'planningvariantId' must be defined.");
        url_ = url_.replace("{planningvariantId}", encodeURIComponent("" + planningvariantId));
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrognose_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrognose_Get(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processPrognose_Get(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    prognose_GetYears(realmId: string): Observable<number[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/forecast/years";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrognose_GetYears(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrognose_GetYears(<any>response_);
                } catch (e) {
                    return <Observable<number[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<number[]>><any>_observableThrow(response_);
        }));
    }

    protected processPrognose_GetYears(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <number[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number[]>(<any>null);
    }
}

export interface ISchulkreisGeneratedClient {
    /**
     * Get the schoolareas with all related GIS data
     */
    schulkreis_Get(realmId: string): Observable<Schoolareas>;
    /**
     * Update the schoolareas (with GIS data)
     * @param schoolareas Schoolareas with GIS data
     */
    schulkreis_Update(schoolareas: Schoolareas, realmId: string): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class SchulkreisGeneratedClient implements ISchulkreisGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    /**
     * Get the schoolareas with all related GIS data
     */
    schulkreis_Get(realmId: string): Observable<Schoolareas> {
        let url_ = this.baseUrl + "/rlm/{realmId}/schoolareas";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchulkreis_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchulkreis_Get(<any>response_);
                } catch (e) {
                    return <Observable<Schoolareas>><any>_observableThrow(e);
                }
            } else
                return <Observable<Schoolareas>><any>_observableThrow(response_);
        }));
    }

    protected processSchulkreis_Get(response: HttpResponseBase): Observable<Schoolareas> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Schoolareas>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Schoolareas>(<any>null);
    }

    /**
     * Update the schoolareas (with GIS data)
     * @param schoolareas Schoolareas with GIS data
     */
    schulkreis_Update(schoolareas: Schoolareas, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/schoolareas";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(schoolareas);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchulkreis_Update(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchulkreis_Update(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSchulkreis_Update(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface ISchülerGeneratedClient {
    /**
     * Get all students
     * @param filterId (optional) Filter (FilterID - AllFilter)
     * @param fremdsprache (optional) 
     * @param klasse (optional) 
     * @param planKlasse (optional) 
     * @param stufe (optional) 
     * @param geschlecht (optional) 
     * @param schulhausTyp (optional) 
     */
    schüler_Get(realmId: string, filterId?: number | null | undefined, fremdsprache?: boolean | null | undefined, klasse?: boolean | null | undefined, planKlasse?: boolean | null | undefined, stufe?: string | null | undefined, geschlecht?: string | null | undefined, schulhausTyp?: string | null | undefined): Observable<Student[]>;
    /**
     * (Re)Create assignments from students to one schoolclasses
    Existing assignments for this period will be deleted (period of provided schoolclass)
     * @param assignments New assignments
     */
    schüler_SetSchoolclassAssignments(assignments: StudentToClassAssignments, realmId: string): Observable<void>;
    /**
     * Delete plan-schoolclass-asssignment of a student for current year
     * @param id Student ID
     */
    schüler_DeletePlanclassAssignments(id: number, realmId: string): Observable<void>;
    /**
     * Batch update perimeters on students
     * @param perimeterAndStudents Perimeters to write
     */
    schüler_SetPerimeter(perimeterAndStudents: PerimeterAndStudent[], realmId: string): Observable<void>;
    /**
     * Get schulweg
     */
    schüler_GetSchulweg(studentId: number, perimeterId: string, realmId: string): Observable<Schulweg[]>;
}

@Injectable({
    providedIn: 'root'
})
export class SchülerGeneratedClient implements ISchülerGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    /**
     * Get all students
     * @param filterId (optional) Filter (FilterID - AllFilter)
     * @param fremdsprache (optional) 
     * @param klasse (optional) 
     * @param planKlasse (optional) 
     * @param stufe (optional) 
     * @param geschlecht (optional) 
     * @param schulhausTyp (optional) 
     */
    schüler_Get(realmId: string, filterId?: number | null | undefined, fremdsprache?: boolean | null | undefined, klasse?: boolean | null | undefined, planKlasse?: boolean | null | undefined, stufe?: string | null | undefined, geschlecht?: string | null | undefined, schulhausTyp?: string | null | undefined): Observable<Student[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/students?";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        if (filterId !== undefined && filterId !== null)
            url_ += "filterId=" + encodeURIComponent("" + filterId) + "&";
        if (fremdsprache !== undefined && fremdsprache !== null)
            url_ += "fremdsprache=" + encodeURIComponent("" + fremdsprache) + "&";
        if (klasse !== undefined && klasse !== null)
            url_ += "klasse=" + encodeURIComponent("" + klasse) + "&";
        if (planKlasse !== undefined && planKlasse !== null)
            url_ += "planKlasse=" + encodeURIComponent("" + planKlasse) + "&";
        if (stufe !== undefined && stufe !== null)
            url_ += "stufe=" + encodeURIComponent("" + stufe) + "&";
        if (geschlecht !== undefined && geschlecht !== null)
            url_ += "geschlecht=" + encodeURIComponent("" + geschlecht) + "&";
        if (schulhausTyp !== undefined && schulhausTyp !== null)
            url_ += "schulhausTyp=" + encodeURIComponent("" + schulhausTyp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchüler_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchüler_Get(<any>response_);
                } catch (e) {
                    return <Observable<Student[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Student[]>><any>_observableThrow(response_);
        }));
    }

    protected processSchüler_Get(response: HttpResponseBase): Observable<Student[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Student[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Student[]>(<any>null);
    }

    /**
     * (Re)Create assignments from students to one schoolclasses
    Existing assignments for this period will be deleted (period of provided schoolclass)
     * @param assignments New assignments
     */
    schüler_SetSchoolclassAssignments(assignments: StudentToClassAssignments, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/students/classassignments";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignments);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchüler_SetSchoolclassAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchüler_SetSchoolclassAssignments(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSchüler_SetSchoolclassAssignments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Delete plan-schoolclass-asssignment of a student for current year
     * @param id Student ID
     */
    schüler_DeletePlanclassAssignments(id: number, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/students/{id}/planassignment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchüler_DeletePlanclassAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchüler_DeletePlanclassAssignments(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSchüler_DeletePlanclassAssignments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Batch update perimeters on students
     * @param perimeterAndStudents Perimeters to write
     */
    schüler_SetPerimeter(perimeterAndStudents: PerimeterAndStudent[], realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/students/perimeters";
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(perimeterAndStudents);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchüler_SetPerimeter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchüler_SetPerimeter(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processSchüler_SetPerimeter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Get schulweg
     */
    schüler_GetSchulweg(studentId: number, perimeterId: string, realmId: string): Observable<Schulweg[]> {
        let url_ = this.baseUrl + "/rlm/{realmId}/students/getSchulweg/{studentId}/{perimeterId}";
        if (studentId === undefined || studentId === null)
            throw new Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        if (perimeterId === undefined || perimeterId === null)
            throw new Error("The parameter 'perimeterId' must be defined.");
        url_ = url_.replace("{perimeterId}", encodeURIComponent("" + perimeterId));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchüler_GetSchulweg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchüler_GetSchulweg(<any>response_);
                } catch (e) {
                    return <Observable<Schulweg[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Schulweg[]>><any>_observableThrow(response_);
        }));
    }

    protected processSchüler_GetSchulweg(response: HttpResponseBase): Observable<Schulweg[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Schulweg[]>JSON.parse(_responseText, this.jsonParseReviver);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Schulweg[]>(<any>null);
    }
}

export interface IZusatzebeneGeneratedClient {
    /**
     * Rename a layer
     * @param id GUID
     * @param name New name
     */
    zusatzebene_Rename(id: string, name: string, realmId: string): Observable<void>;
    /**
     * Delete a layer
     * @param id GUID
     */
    zusatzebene_Delete(id: string, realmId: string): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class ZusatzebeneGeneratedClient implements IZusatzebeneGeneratedClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrlToken) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:51133";
    }

    /**
     * Rename a layer
     * @param id GUID
     * @param name New name
     */
    zusatzebene_Rename(id: string, name: string, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/schoolareas/layer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(name);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processZusatzebene_Rename(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZusatzebene_Rename(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processZusatzebene_Rename(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * Delete a layer
     * @param id GUID
     */
    zusatzebene_Delete(id: string, realmId: string): Observable<void> {
        let url_ = this.baseUrl + "/rlm/{realmId}/schoolareas/layer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (realmId === undefined || realmId === null)
            throw new Error("The parameter 'realmId' must be defined.");
        url_ = url_.replace("{realmId}", encodeURIComponent("" + realmId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processZusatzebene_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processZusatzebene_Delete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processZusatzebene_Delete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export interface Capabilities {
    selectedLayers: number;
    planningvariant: ReadWrite;
    schoolarea: ReadWrite;
    mapcut: ReadWrite;
    dbConfig: ReadWrite;
}

export enum ReadWrite {
    NONE = 0,
    READ = 1,
    WRITE = 2,
}

/** Config */
export interface Config {
    /** Environment */
    env: string;
    /** URL of Auth-Endpoint */
    identityBaseUrl: string;
}

/** Filter */
export interface Filter {
    /** GUID (PlanungsvarianteGUID) */
    id: number;
    /** Name (Bezeichnung) */
    name: string;
}

export interface DynamicFilterEntry {
    key?: string | undefined;
    value?: string | undefined;
}

/** Building */
export interface Building {
    /** ID */
    id: number;
    /** Name (Bezeichnung) */
    name: string;
    /** Strasse */
    strasse?: string | undefined;
    /** PLZ */
    plz?: string | undefined;
    /** Ort */
    ort?: string | undefined;
    /** Typ             */
    typ?: BuildingType | undefined;
    /** Koordinate X */
    koordinateX: number;
    /** KoordinateY */
    koordinateY: number;
}

export enum BuildingType {
    RED = 0,
    BLUE = 1,
    GREEN = 2,
    ORANGE = 3,
}

export interface GebäudeTypeNames {
    key?: string | undefined;
    value?: string | undefined;
}

export interface GisException {
    id: string;
    perimeterID: string;
    "schülerID": number;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;
}

export interface Coordinates {
    /** X1 (South - CH1903+/LV95) */
    x1?: number | undefined;
    /** Y1 (West - CH1903+/LV95) */
    y1?: number | undefined;
    /** X2 (North - CH1903+/LV95) */
    x2?: number | undefined;
    /** Y2 (East - CH1903+/LV95) */
    y2?: number | undefined;
}

/** Schoolclass */
export interface Schoolclass {
    /** ID */
    id: number;
    /** Name (Bezeichnung) */
    name: string;
    /** Teacher (Main) */
    teacher?: string | undefined;
    /** ID of Building */
    buildingId?: number | undefined;
}

/** Planningvariant */
export interface Planningvariant {
    /** GUID (PlanungsvarianteGUID) */
    id: string;
    /** Name (PlanungsvarianteName) */
    name: string;
}

export interface PlanningvariantWithGisDataFront extends Planningvariant {
    perimeter?: PerimeterFront[] | undefined;
    vertices?: VertexFront[] | undefined;
}

export interface PerimeterFront {
    /** GUID */
    id: string;
    /** Bezeichnung */
    bezeichnung: string;
    farbe?: string | undefined;
    planungsvarianteID: string;
    perimeterConnections?: PerimeterVertexConnectionFront[] | undefined;
    gisExceptions?: GisExceptionFront[] | undefined;
}

export interface PerimeterVertexConnectionFront {
    perimeterId: string;
    vertexId: string;
}

export interface GisExceptionFront {
    id: string;
    perimeterID: string;
    "schülerID": number;
}

export interface VertexFront {
    id: string;
    x: number;
    y: number;
    bemerkung?: string | undefined;
    aufRoutingGeometrie: boolean;
    manuell: boolean;
}

/** Schoolareas with GIS data */
export interface Schoolareas {
    zusatzebenen?: Zusatzebene[] | undefined;
    zusatzebeneVertices?: ZusatzebeneV[] | undefined;
}

export interface Zusatzebene {
    /** GUID */
    id: string;
    /** Name */
    name: string;
    zusatzebenePVs?: ZusatzebenePV[] | undefined;
}

export interface ZusatzebenePV {
    zusatzebeneId: string;
    zusatzebeneVId: string;
}

export interface ZusatzebeneV {
    id: string;
    x: number;
    y: number;
    bemerkung?: string | undefined;
    aufRoutingGeometrie: boolean;
    manuell: boolean;
}

/** Student */
export interface Student {
    /** ID */
    id: number;
    /** GUID */
    guid: string;
    /** ID of Schoolclass */
    schoolclassId?: number | undefined;
    /** ID of Schoolclass */
    planclassId?: number | undefined;
    /** Name (Lastname) */
    name: string;
    /** Firstname */
    firstname: string;
    /** Birthday (ISO8601 date) */
    birthday?: string | undefined;
    /** Gender (1 = male, 2 = female, 3 = unknown) */
    gender: Gender;
    /** Speaks foreign language */
    foreignLanguage?: boolean | undefined;
    /** Address */
    address?: string | undefined;
    /** Zipcode */
    zip?: string | undefined;
    /** Town */
    town?: string | undefined;
    /** Coordinate X */
    coordinateE?: number | undefined;
    /** Coordinate Y */
    coordinateN?: number | undefined;
    /** Additional Text for infobox */
    gisRemark?: string | undefined;
}

export enum Gender {
    MALE = 1,
    FEMALE = 2,
    UNKNOWN = 3,
}

export interface StudentToClassAssignments {
    classId: number;
    isPlanklasse: boolean;
    studentIds: number[];
}

export interface PerimeterAndStudent {
    studentId: number;
    perimeterName?: string | undefined;
}

export interface Schulweg {
    gebaeudeId: number;
    gebaeudeBezeichnung?: string | undefined;
    url?: string | undefined;
    buildingType?: BuildingType | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}